// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607281805/js/" + chunkId + "." + {"44":"cff7ca66","225":"58659609","481":"4c41111b","486":"5ebd83d3","770":"21bdf5ec"}[chunkId] + ".0.2118217484152185.chunk.js";
};